import { render, staticRenderFns } from "./CompanyStaffAndPermissions.vue?vue&type=template&id=41b127fd&"
import script from "./CompanyStaffAndPermissions.vue?vue&type=script&lang=js&"
export * from "./CompanyStaffAndPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports